// this is an autogenerated file from DesignSystem/AppsLauncherProperties/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_AppsLauncherProperties(
  $id: String!
  $resource_id: uuid!
  $location_id: uuid!
  $local: jsonb
) {
  apps_launchers_resolve(
    id: $id
    resource_id: $resource_id
    location_id: $location_id
    local: $local
  ) {
    ok
    url
    component
    message
  }
}

`